module.exports = __webpack_public_path__ + "static/media/running_time.f02e2da3.png";